import { render } from "./BgIntroComponent.vue?vue&type=template&id=d240b45c"
import script from "./BgIntroComponent.vue?vue&type=script&lang=js"
export * from "./BgIntroComponent.vue?vue&type=script&lang=js"

import "./BgIntroComponent.vue?vue&type=style&index=0&id=d240b45c&lang=scss"

import exportComponent from "C:\\Users\\grego\\Documents\\Projets_info\\New-project\\gregoire-aimier-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__